export const getUpdatedArray = (
  arr: Array<any>,
  index: number,
  fieldForUpdate: string,
  updatedValue: string | boolean | Date
) => {
  return arr?.map((a, i) => {
    if (i === index) {
      return {
        ...a,
        [fieldForUpdate]: updatedValue
      };
    } else {
      return a;
    }
  });
};
